import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  expanded: {
    margin: 'auto',
  },

  text: {
    fontSize: 14,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    width: '100%',
  },
}))

export default styles
